import type { ElementType } from "react";
import { createElement } from "react";
import type { BoxElement } from "../Box/Box";
import { Flex, type FlexProps } from "../Flex/Flex";

export type InlineProps<T extends BoxElement = "div"> = Omit<FlexProps<T>, "direction" | "wrap">;

export function Inline<T extends BoxElement = "div">({
  align = "center",
  ...rest
}: InlineProps<T>) {
  return createElement(
    Flex as unknown as ElementType,
    {
      "data-component": "Inline",
      ...rest,
      direction: "row",
      wrap: true,
      align,
    } as unknown as FlexProps<T>,
  );
}

Inline.displayName = "Inline";
